<template>
  <div id="oficio-titulo-tool-bar">
    <v-toolbar flat>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            @click="regresar">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <span>Regresar a listado</span>
      </v-tooltip>

      <v-toolbar-title class="display-1">
        <template v-if="cargando">
          <v-skeleton-loader type="text" width="200"></v-skeleton-loader>
        </template>
        <template v-else>
          {{ oficio.numero || 'Oficio de Autorización' }}
        </template>
      </v-toolbar-title>

      <v-chip
        v-if="oficio.tipo"
        class="ml-3"
        :color="oficio.tipo === 'AUTORIZACIÓN' ? 'success' : 'error'"
        text-color="white"
        small>
        <v-icon left x-small>
          {{ oficio.tipo === 'AUTORIZACIÓN' ? 'mdi-check-circle' : 'mdi-close-circle' }}
        </v-icon>
        {{ oficio.tipo }}
      </v-chip>

      <v-chip
        v-if="estadoVencimiento"
        class="ml-2"
        :color="estadoVencimiento.color"
        text-color="white"
        small>
        <v-icon left x-small>{{ estadoVencimiento.icono }}</v-icon>
        {{ estadoVencimiento.texto }}
      </v-chip>

      <v-spacer></v-spacer>

      <!-- Ver PDF -->
      <v-tooltip bottom v-if="oficio.fileData">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            color="primary"
            @click="verPdf">
            <v-icon>mdi-file-pdf-box</v-icon>
          </v-btn>
        </template>
        <span>Ver PDF del oficio</span>
      </v-tooltip>

      <!-- Editar -->
      <v-tooltip bottom v-if="mixValidaScopesActions(2)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            color="secondary"
            @click="editar">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar oficio</span>
      </v-tooltip>

      <!-- Eliminar -->
      <v-tooltip bottom v-if="mixValidaScopesActions(3)">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            color="error"
            @click="eliminar">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Eliminar oficio</span>
      </v-tooltip>
    </v-toolbar>

    <!-- Diálogo Ver PDF -->
    <v-dialog
      v-if="mostrarVerPdf"
      v-model="mostrarVerPdf"
      persistent
      scrollable
      width="750px">
      <v-card>
        <v-card-title>
          {{ oficio.numero }}
          <v-spacer></v-spacer>
          <v-btn icon @click="mostrarVerPdf = false">
            <v-icon class="secondary--text" large>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ver-pdf
            :rutaArchivo="oficio.fileData"
            :nombreArchivoDescarga="`OficioAutorizacion-${oficio.numero}`">
          </ver-pdf>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo Editar -->
    <v-dialog
      v-if="mostrarEditar"
      v-model="mostrarEditar"
      persistent
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-oficio
        :oficioAutorizacionEditar="oficio"
        @cerrar="mostrarEditar = false">
      </editar-oficio>
    </v-dialog>

    <!-- Diálogo Eliminar -->
    <v-dialog
      v-if="mostrarEliminar"
      v-model="mostrarEliminar"
      persistent
      width="450">
      <eliminar-oficio
        :oficioAutorizacionEliminar="oficio"
        @cerrar="cerrarEliminar">
      </eliminar-oficio>
    </v-dialog>
  </div>
</template>

<script>
import VerPdf from '@/components/administracion/auditorias/auditoria/verPdf.vue';
import EditarOficio from '@/components/administracion/programacion/oficiosautorizacion/Editar.vue';
import EliminarOficio from '@/components/administracion/programacion/oficiosautorizacion/Eliminar.vue';

export default {
  name: 'OficioTituloToolBar',
  components: {
    VerPdf,
    EditarOficio,
    EliminarOficio,
  },
  props: {
    oficio: {
      type: Object,
      default: () => ({}),
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarVerPdf: false,
      mostrarEditar: false,
      mostrarEliminar: false,
    };
  },
  computed: {
    /**
     * Calcula el estado de vencimiento del oficio
     */
    estadoVencimiento() {
      if (!this.oficio.fechaVencimiento) return null;

      const hoy = new Date();
      const vencimiento = new Date(this.oficio.fechaVencimiento);
      const diasRestantes = Math.ceil((vencimiento - hoy) / (1000 * 60 * 60 * 24));

      if (diasRestantes < 0) {
        return {
          texto: 'Vencido',
          color: 'error',
          icono: 'mdi-alert-circle',
        };
      }
      if (diasRestantes <= 7) {
        return {
          texto: `Vence en ${diasRestantes}d`,
          color: 'warning',
          icono: 'mdi-clock-alert',
        };
      }
      if (diasRestantes <= 30) {
        return {
          texto: `Vence en ${diasRestantes}d`,
          color: 'info',
          icono: 'mdi-clock-outline',
        };
      }
      return {
        texto: 'Vigente',
        color: 'success',
        icono: 'mdi-check-circle',
      };
    },
  },
  methods: {
    regresar() {
      // Usar back() para navegación más rápida si hay historial
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'programacion' });
      }
    },
    verPdf() {
      this.mostrarVerPdf = true;
    },
    editar() {
      this.mostrarEditar = true;
    },
    eliminar() {
      this.mostrarEliminar = true;
    },
    cerrarEliminar() {
      this.mostrarEliminar = false;
      // Regresar al listado después de eliminar
      this.$router.push({ name: 'programacion' });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
